// extracted by mini-css-extract-plugin
export default {"label":"label--_8xOx","clickable":"clickable--sDZVM"};